import { LocalStorageService } from '../../core/services/local-storage.service';
import { StorageKeys } from '../../shared/models/storage-keys';
import { UserAlias } from '../../shared/constants';
import { DialogMessageType } from '../../shared/models/utility.model';

export class NotificationHelper {
    localStorage: LocalStorageService;

    constructor(localStorage: LocalStorageService) {
        this.localStorage = localStorage;
    }

    switchBusiness(business: any): Promise<any> {
        return new Promise(async (resolve) => {
            this.localStorage.save(StorageKeys.moniepointAgentId, business?.id);
            this.localStorage.save(StorageKeys.selected_role, UserAlias.agent);
            this.localStorage.save(StorageKeys.is_categorized_business, business?.categorized);
            this.localStorage.save(StorageKeys.is_categorized_terminal, business?.terminalCategorized);
            this.localStorage.save(StorageKeys.business_category, business?.businessCategory);
            this.localStorage.save(StorageKeys.business_type, business?.businessType);
            this.localStorage.save(StorageKeys.businessName, business?.businessName);
            resolve(true);
        });
    }
}

export interface Notification {
    actionTaken: boolean;
    actionTakenBy: string;
    actionTakenOn: any;
    body: string;
    extraData: string;
    id: number;
    seen: boolean;
    seenBy: any;
    seenOn: any;
    title: string;
    type: string;
}

export interface NotificationModel {
    content: Notification[];
    totalElements: number;
    totalPages: number;
}

export enum WizardState {
    ACTIVE = 'active',
    COMPLETED = 'completed',
    INACTIVE = 'inactive',
    PROCESSING = 'processing',
    INCOMPLETE = 'incomplete',
    REDO = 're-do',
}

export enum WizardNavigation {
    PREVIOUS,
    NEXT,
}

export enum WizardStepProgression {
    INCREASE_BY_A_STEP = +1,
    DECREASE_BY_A_STEP = -1,
}

export enum KamonaLayoutHeightUnit {
    CUSTOM = '',
    PX = 'px',
    HV = 'hv',
}

export enum KamonaMessageType {
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    OTP_SUSPENSION = 'OTP_SUSPENSION',
}

export enum KamonaFormButtonType {
    DOUBLE_BUTTON,
    SINGLE,
    SINGLE_BUTTON_TEXT,
    MOBILE_DOUBLE_BUTTON,
    MOBILE_BUTTON_TEXT,
}

export enum KamonaModalResponse {
    CONTINUE,
    CLOSE,
    RELOAD,
    RETRY,
    PROCEED,
}

export enum ProgressTimelineType {
    PERCENTAGE = 1,
    REGULAR,
    REGULAR_GREEN,
    TIMER,
}

export const MAX_META_MAP_VERIFICATION_PERIOD_IN_MINUTES = 3;

export enum IdentityVerificationStatus {
    VERIFICATION_IN_PROGRESS = 'VERIFICATION_IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    IN_REVIEW = 'IN_REVIEW',
    PENDING = 'PENDING',
}

export enum KamonaBannerType {
    LARGE = 1,
    MEDIUM,
    SMALL,
}

export enum KamonaDialogDesign {
    OLD,
    NEW,
}

export enum KamonaDialogType {
    BASIC,
    MAXIMIZE,
}

export interface DialogOptionsConfig {
    message: string;
    title: string;
    kamonaDialogType: KamonaDialogType;
    kamonaDialogButtonType: KamonaFormButtonType;
    submitBtn: string;
    closeBtn?: string;
    messageType: DialogMessageType;
    loadingAfterSubmit?: boolean;
}

export enum MetaMapVerificationEvent {
    userFinishedSdk = 'userFinishedSdk',
    userStartedSdk = 'userStartedSdk',
    exitedSdk = 'exitedSdk',
    loaded = 'loaded',
}

export enum CustomTimelineVersion {
    version_1 = 1,
    version_2,
    version_3,
    version_4,
    version_5,
    version_6,
    version_7,
    version_8,
}

export enum SmileIdMode {
    Selfie_Capture = 'Selfie Capture',
    Liveness_Images = 'Liveness Images',
    ID_Card_Photo = 'ID Card Photo',
    Document_Capture = 'Document Capture',
}
export interface SmileIdImage {
    image_type_id: number;
    image: string;
}

export interface SmileIdDetail {
    partner_params: {
        libraryVersion: string;
        permissionGranted: boolean;
    };
    images: SmileIdImage[];
}

export interface SmileIdPayload {
    verificationType?: SmileIDVerificationType;
    images: SmileIdImage[];
    reference?: string;
    jobReference?: string;
}

export const DefaultSmileIdDetail = {
    partner_params: {
        libraryVersion: '',
        permissionGranted: true,
    },
    images: [],
};

export enum IdentityProvider {
    SMILE_ID = 'SMILE_ID',
    METAMAP = 'METAMAP',
    FACETEC = 'FACETEC'
}

export enum SmileIDVerificationType {
    LIVELINESS = 'LIVELINESS',
}

export enum IconType {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    INFO = 'INFO',
}

export enum ModalType {
    DEFAULT,
    CUSTOM,
}

export enum BtnType {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    LOADING = 'LOADING',
    GHOST = 'GHOST',
}

export enum OtpResentMode {
    USSD_MODE = 'USSD_MODE',
    SMS_MODE = 'SMS_MODE',
    WHATSAPP_MODE = 'WHATSAPP_MODE',
}

export type Countdown = { minute: number; second: number; hour?: number };

export interface ModalInfo {
    title?: string;
    description?: string;
    suspensionReleaseTimeEpoch?: number;
    suspensionReleaseTime?: string;
    btnText?: string;
    btnType?: BtnType;
    iconType?: IconType;
    modalType?: ModalType;
}

export const ModalInfo: ModalInfo = {
    title: '',
    description: '',
    suspensionReleaseTimeEpoch: 1708039174562,
    suspensionReleaseTime: '2024-02-16T00:19:34.562',
    btnText: 'Dismiss',
    btnType: BtnType.SECONDARY,
    iconType: IconType.INFO,
    modalType: ModalType.DEFAULT,
};

export const AddressType = ['DUPLEX', 'BUNGALOW', 'MANSION', 'ONE STOREY', 'TWO STOREY', 'THREE STOREY', 'CONDO', 'FLAT', 'OTHERS'];

export const LandMark = ['BUS STOP', 'ROAD BLOCK', 'POLICE STATION', 'BILL BOARD', 'SCHOOL', 'CHURCH', 'MOSQUE', 'BANK', 'OTHERS'];

export const HouseColor = [
    'WHITE',
    'BLACK',
    'CREAM',
    'GREY',
    'RED',
    'GREEN',
    'BLUE',
    'BLACK',
    'YELLOW',
    'ORANGE',
    'BROWN',
    'PURPLE',
    'GOLD',
    'LEMON',
];
export const MeWith = ['SISTER', 'BROTHER', 'COUSIN', 'FRIEND', 'MOTHER', 'FATHER', 'NEIGHBOUR'];

export enum AddressReValidationStep {
    PLACE_OF_RESIDENCE = 1,
    ALLOW_LOCATION_ACCESS,
    CURRENT_ADDRESS,
    SUBMITTED_ADDRESS,
    ADDRESS_MISMATCH,
    UPLOAD_PROOF_OF_ADDRESS,
    RESIDENTIAL_ADDRESS_SAME_AS_BUSINESS,
    ENTER_ADDRESS_MANUALLY,
    FACE_VERIFICATION,
}

export enum AddressCollectionStep {
    OKHI_COLLECTION = 1,
    ENTER_ADDRESS_MANUALLY,
    POST_SUBMISSION,
}

export enum ResidentialAddressVerificationStep {
    LOCATION_ACCESS = 1,
    MOBILE_APP_DOWNLOAD,
    PHYSICAL_ADDRESS_VERIFICATION,
    OKHI_DIGITAL_ADDRESS_VERIFICATION
}

export enum LocationFormType {
    ALLOW_LOCATION_ACCESS = 1,
    SEARCH_LOCATION_ON_MAP,
    UPDATE_ADDRESS,
}

export interface AddressMatchingPayload {
    locationOne: AddressGeolocation;
    locationTwo: AddressGeolocation;
}

export interface AddressGeolocation {
    latitude?: number;
    longitude?: number;
    state?: string;
    lga?: string;
    country?: string;
    city?: string;
    addressLineOne?: string;
    majorLandmark?: string;
    houseNo?: string;
    streetName?: string;
    area?: string;
    notes?: string;
    placeId?: string;
    lgaCode?: string;
    canVerifyBusinessWithResidentialAddress?: boolean;
    proofOfAddressSubmitted?: boolean;
    isPlusCodeType?: boolean;
}

export enum AddressCreationSource {
    OK_HI = 'OK_HI',
    MANUAL_COLLECTION = 'MANUAL_COLLECTION'
}

export interface AddressPayload {
    latitude?: number;
    longitude?: number;
    captureLocationLatitude?: number;
    captureLocationLongitude?: number;
    state?: string;
    stateName?: string;
    localGovernmentCode?: string;
    country?: string;
    countryCode?: string;
    city?: string;
    colorOfHouse?: string;
    addressLineOne?: string;
    addressLineTwo?: string;
    majorLandmark?: string;
    area?: string;
    notes?: string;
    sourceReference?: string;
    reference?: string;
    type?: string;
    source?: AddressCreationSource;
}

export interface codeMessageObject {
    code: string;
    message: string;
}

export enum DigitalVerificationAppliedStrategyResultCodes {
    IN_PROGRESS = 'IN_PROGRESS',
    UNSUPPORTED = 'UNSUPPORTED',
    ADDRESS_OLD = 'ADDRESS_OLD',
    NOT_IN_COUNTRY = 'NOT_IN_COUNTRY',
    GENERIC_ERROR = 'GENERIC_ERROR'
}
export const DigitalVerificationAppliedStrategyModalContents: Record<string, any> = {
    IN_PROGRESS: {
        modalTitle: 'In Progress',
        modalDescription: 'Digital verification is in progress, you will be notified once completed',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
    UNSUPPORTED: {
        modalTitle: 'Digital verification unavailable',
        modalDescription: 'We are unable to verify your residential address digitally while you are outside the country, will you like to go ahead with physical verification?',
        proceedText: 'Continue with physical verification',
        cancelText: 'Try again later',
        showCancelText: true,
    },
    ADDRESS_OLD: {
        modalTitle: 'Address Old',
        modalDescription: 'Address collected more than 2 years ago',
        proceedText: 'Enter new address',
        cancelText: 'Continue later',
        showCancelText: true,
    },
    NOT_IN_COUNTRY: {
        modalTitle: 'Confirm Your Location',
        modalDescription: 'Kindly confirm your location, as we’ve detected that you’re outside Nigeria.',
        proceedText: 'I Am Outside Nigeria',
        cancelText: 'I Am In Nigeria',
        showCancelText: true,
    },
    GENERIC_ERROR: {
        modalTitle: 'Error',
        modalDescription: 'Unable to proceed with your verification. Please try again later',
        proceedText: 'Try again',
        cancelText: 'Dismiss',
        showCancelText: true,
    },
};


export enum PhysicalVerificationDryRunResultCode {
    COMPLETED = 'COMPLETED',
    ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
    VERIFICATION_NOT_FOUND = 'VERIFICATION_NOT_FOUND',
    STRATEGY_UNSUPPORTED = 'STRATEGY_UNSUPPORTED',
    STRATEGY_NOT_ALLOWED = 'STRATEGY_NOT_ALLOWED',
    VERIFICATION_NOT_ALLOWED = 'VERIFICATION_NOT_ALLOWED',
    GENERIC_ERROR = 'GENERIC_ERROR'
}
export enum PhysicalVerificationDryRunStrategy {
    OKHI_DIGITAL_VERIFICATION = 'OKHI_DIGITAL_VERIFICATION',
    FVS_VERIFICATION = 'FVS_VERIFICATION'
}

export const PhysicalVerificationDryModalContents: Record<string, any> = {
    ADDRESS_NOT_FOUND: {
        modalTitle: 'Address not found',
        modalDescription: 'The provided address was not found, please go back to Address collection',
        proceedText: 'Enter new address',
        cancelText: 'Continue later',
        showCancelText: true,
    },
    STRATEGY_NOT_ALLOWED: {
        modalTitle: 'Strategy Not Allowed',
        modalDescription: 'The selected physical verification method is not allowed',
        proceedText: 'Try another',
        cancelText: 'Dismiss',
        showCancelText: true,
    },
    STRATEGY_UNSUPPORTED: {
        modalTitle: 'Strategy Not Supported',
        modalDescription: 'The selected strategy is not supported',
        proceedText: 'Try another',
        cancelText: 'Dismiss',
        showCancelText: true,
    },
    VERIFICATION_NOT_FOUND: {
        modalTitle: 'Verification Not Found',
        modalDescription: 'Physical verification details not found for this account',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
    VERIFICATION_NOT_ALLOWED: {
        modalTitle: 'Verification Not Allowed',
        modalDescription: 'You have initiatied too many verification requests recently. Try again later.',
        proceedText: 'Try again later',
        showCancelText: false,
    },
    GENERIC_ERROR: {
        modalTitle: 'Error',
        modalDescription: 'Unable to proceed with your verification. Please try again later',
        proceedText: 'Try again',
        cancelText: 'Dismiss',
        showCancelText: true,
    },
};

export interface OkHiAddress {
    geo_point: {
        lon: number;
        lat: number;
    };
    id: string;
    user_id: string;
    url: string;
    street_name: string;
    lga: string;
    state: string;
    city: string;
    country: string;
    address_line_1: string;
    directions?: string;
    display_title: string;
    street_view?: {
        geo_point: {
            lon: number;
            lat: number;
        };
        pano_id: string;
        url: string;
    };
}
type OkhiCallBack = (address: OkHiAddress) => void;
export interface OkHiProps {
    API_KEY: string;
    userFirstName: string;
    userLastName: string;
    userPhoneNumber: string;
    email: string;
    streetviewEnabled?: boolean;
    toTheDoorEnabled?: boolean;
    isDarkMode?: boolean;
    createOnly?: boolean;
    requiredFieldsConfig?: {
        buildingNameOrNumber: boolean;
    };
    styleSettings: {
        primaryColor: string;
        highlightColor: string;
    };
    appSettings: {
        name: string;
        version: string;
    };
    onAddressSelected: OkhiCallBack;
    onError: (error: Error) => void;
}

export interface CurrentLocation {
    latitude: number;
    longitude: number;
}

export interface ProofOfAddress {
    fileReference: string;
    type: string;
}

export interface PhysicalAddressPayload {
    address: AddressGeolocation;
    currentLocation?: CurrentLocation;
    proofOfAddress?: ProofOfAddress;
    assigneeEmail?: string;
}

export const CustomBlueGoogleMapMarker = '../assets/images/svgs/custom-blue-google-map-marker.svg';
export const CustomBlueSMGoogleMapMarker = '../assets/images/svgs/custom-blue-sm-google-map-marker.svg';
export const CustomBlackSMGoogleMapMarker = '../assets/images/svgs/custom-black-sm-google-marker.svg';

export const DefaultProofOfAddressTypesV2: ProofOfAddressTypeV2[] = [
    {
        name: 'Electricity Bill',
        note: 'Legal agreement for your apartment',
        documentType: 'UTILITY_BILL',
        requirements: 'Valid for 3 months before today',
    },
    {
        name: 'Voter’s Card',
        note: 'Legal agreement for your apartment',
        documentType: 'VOTER_CARD',
    },
    {
        name: 'Driver’s License',
        note: 'Legal agreement for your apartment',
        documentType: 'DRIVER_LICENCE',
    },
    {
        name: 'Rent Receipt',
        note: 'Receipt for your rent payment',
        documentType: 'RENT_RECEIPT',
    },
    {
        name: 'NIN Slip',
        note: 'Legal agreement for your apartment',
        documentType: 'NIN_SLIP',
        requirements: 'Must show active residential address',
    },
    {
        name: 'Tenancy Agreement',
        note: 'Legal agreement for your apartment',
        documentType: 'TENANCY_AGREEMENT',
        requirements: 'Valid for a year before today',
    },
    {
        name: 'Letter of residency',
        documentType: 'LETTER_OF_RESIDENCY',
        note: 'GRA or Military barracks residents only',
    },
    {
        name: "Solicitor's Letter",
        documentType: 'SOLICITOR_LETTER',
        note: 'Legal agreement form Solicitor',
    },
    {
        name: 'Water Bill',
        documentType: 'UTILITY_BILL',
        note: 'Legal agreement for your apartment',
        requirements: 'Valid for 3 months before today',
    },
    {
        name: 'Waste Management Bill',
        documentType: 'UTILITY_BILL',
        note: 'Legal agreement for your apartment',
        requirements: 'Valid for 3 months before today',
    },
    {
        name: 'Account Statement',
        note: 'Legal agreement for your apartment',
        documentType: 'ACCOUNT_STATEMENT',
        requirements: 'Valid for 3 months before today',
    },
    {
        name: 'Tax Receipt',
        documentType: 'TAX_RECEIPT',
        note: 'Legal agreement for your apartment',
    },
];

export interface ProofOfAddressTypeV2 {
    icon?: string;
    documentType?: string;
    name?: string;
    note?: string;
    sample?: string;
    requirements?: string;
}

export const DefaultProofOfAddressTypes: ProofOfAddressType[] = [
    {
        displayName: 'Electricity Bill',
        note: 'Legal agreement for your apartment',
        documentType: 'UTILITY_BILL',
        requirements: ['Postpaid or Prepaid', 'Valid for 3 months before today'],
    },
    {
        displayName: 'Voter’s Card',
        note: 'Legal agreement for your apartment',
        documentType: 'VOTER_CARD',
    },
    {
        displayName: 'Driver’s License',
        note: 'Legal agreement for your apartment',
        documentType: 'DRIVER_LICENCE',
    },
    {
        displayName: 'Rent Receipt',
        note: 'Receipt for your rent payment',
        documentType: 'RENT_RECEIPT',
    },
    {
        displayName: 'NIN Slip',
        note: 'Legal agreement for your apartment',
        documentType: 'NIN_SLIP',
        requirements: ['Must show active residential address'],
    },
    {
        displayName: 'Tenancy Agreement',
        note: 'Legal agreement for your apartment',
        documentType: 'TENANCY_AGREEMENT',
        requirements: ['Valid for a year before today'],
    },
    {
        displayName: 'Letter of residency',
        documentType: 'LETTER_OF_RESIDENCY',
        note: 'GRA or Military barracks residents only',
    },
    {
        displayName: "Solicitor's Letter",
        documentType: 'SOLICITOR_LETTER',
        note: 'Legal agreement form Solicitor',
    },
    {
        displayName: 'Water Bill',
        documentType: 'UTILITY_BILL',
        note: 'Legal agreement for your apartment',
        requirements: ['Valid for 3 months before today'],
    },
    {
        displayName: 'Waste Management Bill',
        documentType: 'UTILITY_BILL',
        note: 'Legal agreement for your apartment',
        requirements: ['Valid for 3 months before today'],
    },
    {
        displayName: 'Account Statement',
        note: 'Legal agreement for your apartment',
        documentType: 'ACCOUNT_STATEMENT',
        requirements: ['Valid for 3 months before today'],
    },
    {
        displayName: 'Tax Receipt',
        documentType: 'TAX_RECEIPT',
        note: 'Legal agreement for your apartment',
    },
];

export interface ProofOfAddressType {
    icon?: string;
    documentType?: string;
    displayName?: string;
    note?: string;
    sample?: string;
    requirements?: string[];
}

export interface AddressComponent {
    longName: string;
    shortName: string;
    types: string[];
}

export interface GeometryLocation {
    lat: number;
    lng: number;
}

export interface Geometry {
    location: GeometryLocation;
}

export interface GeocodingResult {
    addressComponents: AddressComponent[];
    formattedAddress: string;
    geometry: Geometry;
    types: string[];
}

export interface GeocodingResponse {
    status: string;
    results: GeocodingResult[];
}
export interface AddressPrediction {
    description: string;
    placeId: string;
}

export interface AddressPredictionResponse {
    status: string;
    results: AddressPrediction[];
}

export enum RevalidationAddressType {
    RESIDENTIAL = 'residential',
    BUSINESS = 'business',
}
export enum RevalidationAddressTypeV2 {
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
}

export const DefaultGeolocation: AddressGeolocation = {
    addressLineOne: '12 Wole Ariyo St, Lekki Phase 1, Lekki Eti-Osa, Lagos State',
    longitude: 3.458687,
    latitude: 6.442801,
    lga: 'ETI-OSA',
    state: 'Lagos',
    country: 'Nigeria',
    streetName: 'Wole Ariyo St, Lekki Phase 1',
    houseNo: '12',
    city: 'Lekki',
};

export enum GeolocationType {
    ADMINISTRATIVE_AREA_LEVEL_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
    COUNTRY = 'COUNTRY',
    ADMINISTRATIVE_AREA_LEVEL_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
    STREET_NUMBER = 'STREET_NUMBER',
    STREET_ADDRESS = 'STREET_ADDRESS',
    NEIGHBORHOOD = 'NEIGHBORHOOD',
    ROUTE = 'ROUTE',
    LOCALITY = 'LOCALITY',
    plus_code = 'plus_code',
}
